import { render, staticRenderFns } from "./HomePriceSliderCard.vue?vue&type=template&id=c928b906&scoped=true"
import script from "./HomePriceSliderCard.vue?vue&type=script&lang=js"
export * from "./HomePriceSliderCard.vue?vue&type=script&lang=js"
import style0 from "./HomePriceSliderCard.vue?vue&type=style&index=0&id=c928b906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c928b906",
  null
  
)

export default component.exports